import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { PORT_RESTRICTIONS } from 'constants/ports';
import './PortRestrictions.scss';

const PortRestrictionsView = ({ values = {} }) => (
    <div className="port-restrictions-block">
        <div className="restrictions-grid">
            {PORT_RESTRICTIONS.map(({ name, label }) => (
                <div key={name} className="restriction-item">
                    <TextField
                        floatingLabelText={label}
                        value={values[name] || ''}
                        style={{ fontSize: '12px' }}
                        disabled
                        fullWidth
                    />
                </div>
            ))}
        </div>
    </div>
);

PortRestrictionsView.propTypes = {
    values: PropTypes.object.isRequired,
};

export default PortRestrictionsView;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsView.jsx